// extracted by mini-css-extract-plugin
export default {"profileContainer":"CandidateSituationProfile_profileContainer__WgQBh","situation":"CandidateSituationProfile_situation__etg+k","nowrap":"CandidateSituationProfile_nowrap__cjeTY"};